import enRoadmap from './en';
import ruRoadmap from './ru';

export default {
  en: {
    ...enRoadmap,
  },
  ru: {
    ...ruRoadmap,
  },
};
